// 자동 생성됨 — regenerate: python3 scripts/gen_spr_speeds.py
//
// 원본: DB spr_actions 테이블. 서버 jp.l1j.server.datatables.SprTable과
// 같은 분기·같은 계산식으로 뽑았다.
//   calcActionSpeed = (int)(frame_count * 40 * (24.0 / frame_rate))  (SprTable.java:138)
//
// AcceleratorChecker가 이 값을 rightInterval로 쓴다. 서버 판정을 통과하려면
// (실제 간격) * 1.95 >= rightInterval, 즉 간격 >= rightInterval / 1.95 이어야 한다.
// 이 배율은 생성 시점의 config/server.properties.xml에서 읽었다
// (CheckStrictness=200 -> (200-5)/100 = 1.95).
// web-client의 SERVER_CHECK_STRICTNESS도 같은 값이어야 한다. 서버 설정을
// 바꿨다면 이 파일을 재생성하고 그 상수도 함께 고칠 것.
// 담은 spr은 플레이어 클래스 gfx 14종뿐이다 (spriteLoader.ts CLASS_GFX_IDS).

export interface SprSpeed {
  move: Readonly<Record<number, number>>;
  attack: Readonly<Record<number, number>>;
}

/** ActionCodes.ACTION_Walk — getMoveSpeed의 폴백 act_id. */
const ACTION_WALK = 0;
/** ActionCodes.ACTION_Attack — getAttackSpeed의 폴백 act_id. */
const ACTION_ATTACK = 1;

export const SPR_SPEEDS: Readonly<Record<number, SprSpeed>> = {
  0: {
    move: { 0: 640, 4: 640, 11: 640, 20: 640, 24: 640, 40: 640, 46: 640, 50: 640 },
    attack: { 1: 800, 5: 960, 12: 880, 21: 1200, 25: 840, 41: 880, 47: 840, 51: 1120, 55: 960 },
  },
  1: {
    move: { 0: 640, 4: 640, 11: 640, 20: 640, 24: 640, 40: 640, 46: 640, 50: 640 },
    attack: { 1: 800, 5: 960, 12: 880, 21: 1200, 25: 840, 41: 880, 47: 840, 51: 1120, 55: 960 },
  },
  37: {
    move: { 0: 640, 4: 640, 11: 640, 20: 640, 24: 640, 40: 640, 46: 640 },
    attack: { 1: 760, 5: 840, 12: 1040, 21: 960, 25: 1160, 41: 1040, 47: 760 },
  },
  48: {
    move: { 0: 640, 4: 640, 11: 640, 20: 640, 24: 640, 40: 640, 46: 640, 50: 640 },
    attack: { 1: 800, 5: 880, 12: 960, 21: 1440, 25: 840, 41: 960, 47: 840, 51: 1000, 55: 880 },
  },
  61: {
    move: { 0: 640, 4: 640, 11: 640, 20: 640, 24: 640, 40: 640, 46: 640, 50: 640 },
    attack: { 1: 800, 5: 880, 12: 960, 21: 1440, 25: 840, 41: 960, 47: 840, 51: 1000, 55: 880 },
  },
  138: {
    move: { 0: 640, 4: 640, 11: 640, 20: 640, 24: 640, 40: 640, 46: 640 },
    attack: { 1: 760, 5: 840, 12: 1040, 21: 960, 25: 1040, 41: 1040, 47: 760 },
  },
  734: {
    move: { 0: 640, 4: 640, 11: 640, 20: 640, 24: 640, 40: 640, 46: 640 },
    attack: { 1: 880, 5: 1000, 12: 1120, 21: 1680, 25: 1120, 41: 1120, 47: 920 },
  },
  1186: {
    move: { 0: 640, 4: 640, 11: 640, 20: 640, 24: 640, 40: 640, 46: 640 },
    attack: { 1: 880, 5: 1000, 12: 1120, 21: 1680, 25: 1120, 41: 1120, 47: 920 },
  },
  2786: {
    move: { 0: 640, 4: 640, 20: 640, 46: 640, 54: 640, 58: 640, 62: 640 },
    attack: { 1: 760, 5: 880, 12: 760, 21: 1120, 47: 680, 55: 1040, 59: 800, 63: 960 },
  },
  2796: {
    move: { 0: 640, 4: 640, 20: 640, 46: 640, 54: 640, 58: 640, 62: 640 },
    attack: { 1: 800, 5: 880, 12: 760, 21: 1120, 47: 680, 55: 1040, 59: 800, 63: 960 },
  },
  6650: {
    move: { 0: 640, 11: 640, 20: 640, 40: 640, 58: 640 },
    attack: { 1: 800, 12: 920, 21: 1120, 41: 880, 55: 880, 59: 880 },
  },
  6658: {
    move: { 0: 640, 4: 640, 11: 640, 24: 640, 50: 640, 62: 640 },
    attack: { 1: 800, 5: 960, 12: 880, 25: 960, 41: 960, 51: 920, 55: 920, 63: 960 },
  },
  6661: {
    move: { 0: 640, 4: 640, 11: 640, 24: 640, 50: 640, 62: 640 },
    attack: { 1: 920, 5: 960, 12: 880, 25: 960, 41: 960, 51: 920, 55: 920, 63: 960 },
  },
  6671: {
    move: { 0: 640, 11: 640, 20: 640, 40: 640, 58: 640 },
    attack: { 1: 800, 12: 920, 21: 1120, 41: 880, 55: 880, 59: 880 },
  },
};

/** 서버 SprTable.getAttackSpeed와 같은 폴백 규칙. 모르면 null. */
export function attackSpeedOf(sprId: number, actId: number): number | null {
  const spr = SPR_SPEEDS[sprId];
  if (!spr) return null;
  const speed = spr.attack[actId];
  if (speed !== undefined) return speed;
  // 해당 무기 act_id가 없으면 맨손 공격(ACTION_Attack)으로 폴백한다.
  // 서버는 이 자리에서 0을 돌려주지만(제한 없음), 클라이언트는 호출부가
  // 스스로 안전한 기본값을 고를 수 있도록 null로 알린다.
  if (actId === ACTION_ATTACK) return null;
  const fallback = spr.attack[ACTION_ATTACK];
  return fallback !== undefined ? fallback : null;
}

/** 서버 SprTable.getMoveSpeed와 같은 폴백 규칙. 모르면 null. */
export function moveSpeedOf(sprId: number, actId: number): number | null {
  const spr = SPR_SPEEDS[sprId];
  if (!spr) return null;
  const speed = spr.move[actId];
  if (speed !== undefined) return speed;
  // 해당 무기 act_id가 없으면 맨손 걷기(ACTION_Walk)로 폴백한다.
  if (actId === ACTION_WALK) return null;
  const fallback = spr.move[ACTION_WALK];
  return fallback !== undefined ? fallback : null;
}
